import React, { useRef, useState, useEffect } from "react";
import { Formik, Field } from "formik";
import { Button, FormGroup, Label, Row, Col } from "reactstrap";
import { cloneDeep } from "lodash";
import * as Yup from "yup";
import CoveredEntity from "components/CoveredEntity";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import useAxios from "hooks/useAxios";
import reseticon from "assets/icon/reset.svg";
import { ModuleAccess } from "utils/moduleaccess";
import searchicon from "assets/icon/search.svg";
import search from "assets/icon/search.svg";
import ProgramNotes from "assets/icon/ProgramNotes.svg";

const validationSchema = Yup.object({
  coveredEntityName: Yup.string().required("Please select covered entity"),
});
let ceid = ""
const SearchContainer = ({
  handleUpdateEntity,
  handleInvoiceStatus,
  onSearch,
  onManualSearch,
  onReset,
  initialValue,
  orgId,
  onCoverdEntityChange,
  selectedCEId,
}) => {
  const API = useAxios();
  const [isManualInvoice, SetIsManualInvoice] = useState(false);
  const [selectedCE, setSelectedCE] = useState(selectedCEId);
  const [error, setError] = useState(false)
  const [state, updateState] = useState({
    selectedCoveredEntity: {},
    invoiceStatusDesc: "",
    invoiceStatus: [],
    loading: false,
  });
  useEffect(() => {
    ceid = selectedCE
  }, [selectedCE])

  const formikRef = useRef();
  useEffect(() => {
    SetIsManualInvoice(false);
    setState({ loading: true });
    fetchInvoiceStatus();
  }, []);


  useEffect(() => {
    if (orgId) {
      SetIsManualInvoice(false)
    }
    setSelectedCE("")
    setError(false)
    // window.selectedCoveredEntittyId=""
  }, [orgId])
  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const fetchInvoiceStatus = async () => {
    try {
      const { data } = await API.get("Config/TypeStatus/InvoiceStatus");
      if (data) {
        setState({
          invoiceStatus: data,
          loading: false,
        });
      } else {
        setState({ loading: false });
      }
    } catch (error) {
      setState({ loading: false });
    }
  };

  const handleCoverdEntityChange = async (
    value,
    coveredEnty,
    setFieldValue,

  ) => {

    window.selectedCoveredEntittyId = value;
    setSelectedCE(value);
    ceid = value
    handleUpdateEntity(coveredEnty);
    setFieldValue("coveredEntityName", value);
    setState({
      selectedCoveredEntity: coveredEnty,
    });
    if (ceid) {
      setError(false)
    }
    SetIsManualInvoice(coveredEnty.invoiceCycleID == 210005 ? true : false);
  };
  console.log(selectedCE, "selected,", ceid)
  const handleSubmit = async (val, actions) => {
    if (selectedCE == "") {
      setError(true)
      return;
    }
    else {
      setError(false)
    }
    const { setSubmitting } = actions;
    const values = cloneDeep(val);
    await onSearch(values);
    setSubmitting(false);
  };

  const handleBoundChange = (e, setFieldValue) => {
    const { value } = e.target;
    handleInvoiceStatus({ invoiceStatusName: value });
    setFieldValue("invoiceStatusName", value);
    setState({ invoiceStatusDesc: value });
  };

  const handleReset = () => {
    const { resetForm } = formikRef.current;
    resetForm();
    SetIsManualInvoice(false);
    onReset();
    setState({
      selectedCoveredEntity: {},
      invoiceStatusDesc: "",
    });
    window.selectedCoveredEntittyId = "";
    setSelectedCE("");
    setError(false)
  };

  // const handleInvoiceStatusChange = async (
  //   value,
  //   setFieldValue,
  //   invoiceStatus
  // ) => {
  //   handleInvoiceStatus(invoiceStatus)
  //   setFieldValue("invoiceStatus", value);
  // };

  const { invoiceStatusDesc, invoiceStatus, selectedCoveredEntity } = state;

  const handleManual = async () => {
    let ceFilters = selectedCoveredEntity;
    ceFilters.invoiceID = 0;
    await onManualSearch(ceFilters);
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        onSubmit={handleSubmit}
        initialValues={initialValue}
        // validationSchema={validationSchema}
        children={(props) => {
          const { isSubmitting, handleSubmit, setFieldValue } = props;
          return (
            <div>
              <div className="d-flex justify-content-between align-items-center position-relative">
                <div>
                  <h5 className="f-16 text-primary font-weight-700">
                    Search Invoice
                  </h5>
                </div>
                <div>
                  <Button
                    hidden={!isManualInvoice || !ModuleAccess("INV", "MIG")}
                    onClick={handleManual}
                    color="primary"
                    className="reset ms-2" style={{ position: "absolute", right: "0" }}
                  >
                    <span className="right_5">
                      <img src={ProgramNotes} alt="" />
                    </span>{" "}
                    Manual
                  </Button>
                </div>
              </div>
              <Row sm={5}>
                <Col md={3} sm={3} xs={3}>
                  {" "}
                  <FormGroup>
                    <Label for="coveredEntityID">Covered Entity</Label>
                    <CoveredEntity
                      value={selectedCE}
                      orgId={orgId}
                      name="coveredEntityName"
                      onChange={(value, coveredEnty) =>
                        handleCoverdEntityChange(
                          value,
                          coveredEnty,
                          setFieldValue
                        )
                      }
                    />
                    {error == true ? (
                      <div className="text-danger f-12 position-absolute">
                        {"Please select Covered Entity"}
                      </div>
                    ) : null}
                  </FormGroup>

                </Col>
                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label for="invoiceStatusID">Invoice Status</Label>
                    <Field
                      name="invoiceStatusName"
                      type="text"
                      value={invoiceStatusDesc}
                      onChange={(e) => handleBoundChange(e, setFieldValue)}
                      component={FormikSelectField}
                      options={invoiceStatus}
                      defaultoption="--Select--"
                      keys={{
                        id: "id",
                        label: "description",
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {/* <Col md={2} sm={3} xs={6}>
                  {" "}
                  <FormGroup>
                    <Label for="invoiceStatusID">Invoice Status</Label>
                    <CoveredEntity
                      name="invoiceStatus"
                      onChange={(value, invoiceStatus) =>
                        handleInvoiceStatusChange(value, setFieldValue, invoiceStatus)
                      }
                    />
                  </FormGroup>
                </Col> */}
              <Row
                style={{
                  justifyContent: "flex-end",
                  // marginRight: "10px",
                }}
              >
                <Col md="auto" className="pt-4 mt-1">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="search"
                  >
                    <span className="right_5">
                      <img src={search} alt="" />
                    </span>{" "}
                    Search
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => handleReset(props)}
                    className="reset ms-2"
                  >
                    <span className="right_5">
                      <img src={reseticon} alt="" />
                    </span>{" "}
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    </>
  );
};

export default SearchContainer;
